import React, { useState } from 'react';
import zaneImg from '../../assets/zane headshot.jpeg';
import jaggerImg from '../../assets/jagger headshot.jpeg';
import chrisImg from '../../assets/Chris Johnson Headshot.jpeg';
import linkedinIcon from '../../assets/linkedin-icon.svg';
import twitterIcon from '../../assets/twittericon.svg';
import youtubeIcon from '../../assets/youtube-icon.svg';

const LeadershipGrid = () => {
  const [selectedMember, setSelectedMember] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const teamMembers = [
    {
      id: 1,
      name: 'Zane Schartz',
      role: 'Founder & Fund Manager',
      image: zaneImg,
      shortBio: 'Founder of Real World Equity and President of Freedom Commercial Real Estate. 9+ years in private-equity CRE, managed multiple funds and 70+ assets with national-credit tenants.',
      fullBio: 'Zane Schartz is the founder of Real World Equity. He is also the President and Founder of Freedom Commercial Real Estate. With over 9 years of expertise in private equity real estate investing, Zane has managed a portfolio of six commercial real estate funds and over 70 assets, totaling more than $700 million in assets under management. He\'s also a partner in $300 million worth of commercial real estate and directly oversees $175 million in commercial assets. Zane\'s approach focuses on using innovative strategies and relationships to maximize investor returns and create lasting wealth. A former professional hockey player, Zane graduated from Liberty University with a degree in business marketing and management. After graduation, he went on to play professional hockey for three years in North America and Europe. Zane attends Eastside Community Church in Dallas, TX. His biggest goal in life is to create a non-profit organization that funds Christian missionaries around the world.',
      socialLinks: {
        linkedin: 'https://www.linkedin.com/in/zaneschartz/',
        twitter: 'https://twitter.com/zaneschartz',
        youtube: 'https://www.youtube.com/@ZaneSchartzRE'
      },
      hasFullBio: true
    },
    {
      id: 2,
      name: 'Chris Johnson',
      role: 'Founder & Strategic Advisor',
      image: chrisImg,
      shortBio: 'Strategic advisor with deep expertise in business development and market expansion. Brings valuable insights and guidance to drive Real World Equity\'s growth and success.',
      fullBio: 'Chris has a passion for solving problems and building teams. He is an 8x founder all with successful outcomes, including his first start up that battled from bootstrap to a $90M enterprise. His experience is broad: from smart home tech and custom software systems, to marble and granite imports and commercial electrical systems. He is currently working with a team to simplify the way we monitor and track remote assets.\n\nChris has led teams responsible for the execution of marketing, lead generation, sales, product management, custom software development, customer support, and finance. His drive for growth has been enabled by a customer-centric philosophy and a data-driven approach to decision making.\n\nHis passion for building is second only to life with his wonderful wife and six amazing children, who let him pretend to be a chef at home on the weekends.',
      socialLinks: {
        linkedin: 'https://www.linkedin.com/in/chrisjohnsonalarm/',
        twitter: 'https://twitter.com/chrisjohnson',
        youtube: 'https://youtube.com/@chrisjohnson'
      },
      hiddenSocial: ['youtube', 'twitter'],
      hasFullBio: true
    },
    {
      id: 3,
      name: 'Jagger Luce',
      role: 'Director of Growth & Partnerships',
      image: jaggerImg,
      shortBio: 'A leader in investor acquisition and GTM, having developed strategies that have helped clients secure over $1 billion in capital in the past three years.',
      fullBio: 'Jagger Luce is a dad of two, blockchain strategist, and capital markets expert. As the CEO and Co-Founder of Mustard Capital, he is a leader in investor acquisition and GTM, having developed strategies that have helped clients secure over $1 billion in capital in the past three years. He is also widely recognized as a trusted source of institutional-grade deal flow for investors. His work spans collaborations with broker-dealers, investment banks, securities attorneys, PE/VC firms, and family offices, giving him a unique vantage point at the intersection of traditional finance and blockchain innovation. Jagger is at the forefront of advancing asset and equity tokenization, where his vision and expertise are redefining how investors access, evaluate, and engage with capital markets worldwide.',
      socialLinks: {
        linkedin: 'https://www.linkedin.com/in/jagger-luce/',
        twitter: 'https://twitter.com/jaggerluce',
        youtube: 'https://www.linkedin.com/in/jagger-luce/'
      },
      hiddenSocial: ['twitter', 'youtube'],
      hasFullBio: true
    }
  ];

  const openModal = (member) => {
    setSelectedMember(member);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedMember(null);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  const renderAvatar = (member) => {
    if (member.image) {
      return (
        <img
          src={member.image}
          alt={`${member.name} headshot`}
          loading="lazy"
          decoding="async"
        />
      );
    }
    return (
      <div className="leadership-avatar-initials">
        {member.name.split(' ').map(n => n[0]).join('')}
      </div>
    );
  };

  const renderSocialLinks = (member) => {
    if (!member.socialLinks) return null;

    const socialPlatforms = [
      { key: 'linkedin', name: 'LinkedIn', icon: linkedinIcon },
      { key: 'twitter', name: 'Twitter', icon: twitterIcon },
      { key: 'youtube', name: 'YouTube', icon: youtubeIcon }
    ];

    return (
      <div className="leadership-social-links">
        <h4 className="connect-title">Connect With {member.name.split(' ')[0]}</h4>
        <div className="social-icons">
          {socialPlatforms.map(platform => {
            if (member.socialLinks[platform.key] && !member.hiddenSocial?.includes(platform.key)) {
              return (
                <a
                  key={platform.key}
                  href={member.socialLinks[platform.key]}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`social-icon ${platform.key}`}
                  onClick={(e) => e.stopPropagation()}
                  title={platform.name}
                >
                  <img src={platform.icon} alt={platform.name} className="social-icon-img" />
                </a>
              );
            }
            return null;
          })}
        </div>
      </div>
    );
  };

  return (
    <>
      <section className="leadership-section">
        <div className="leadership-container">
          <h2 className="leadership-title">
            Leadership
          </h2>
          
          <div className="leadership-grid">
            {teamMembers.map((member) => (
              <div
                key={member.id}
                className="leadership-card"
                onClick={() => openModal(member)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => e.key === 'Enter' && openModal(member)}
              >
                <div className="leadership-avatar">
                  {renderAvatar(member)}
                </div>
                
                <h3 className="leadership-name">
                  {member.name}
                </h3>
                
                <div className="leadership-role">
                  {member.role}
                </div>
                
                <p className="leadership-bio">
                  {member.shortBio}
                </p>
                
                {renderSocialLinks(member)}
                
                {!member.hasFullBio && (
                  <div className="leadership-todo">
                    TODO: Add full bio
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && selectedMember && (
        <div
          className="team-modal-overlay"
          onClick={closeModal}
          onKeyDown={handleKeyDown}
        >
          <div
            className="team-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <div className="team-modal-header">
              <div>
                <h2 id="modal-title" className="team-modal-title">
                  {selectedMember.name}
                </h2>
                <div className="team-modal-role">
                  {selectedMember.role}
                </div>
              </div>
              <button
                onClick={closeModal}
                className="team-modal-close"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>
            
            <div className="team-modal-body">
              <div id="modal-description" className="team-modal-bio">
                {selectedMember.fullBio}
              </div>
              
              {selectedMember.socialLinks && (
                <div className="modal-social-links">
                  <h4>Connect With {selectedMember.name.split(' ')[0]}</h4>
                  <div className="modal-social-icons">
                    {selectedMember.socialLinks.linkedin && !selectedMember.hiddenSocial?.includes('linkedin') && (
                      <a
                        href={selectedMember.socialLinks.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="modal-social-link linkedin"
                      >
                        <img src={linkedinIcon} alt="LinkedIn" className="modal-social-icon-img" />
                        LinkedIn
                      </a>
                    )}
                    {selectedMember.socialLinks.twitter && !selectedMember.hiddenSocial?.includes('twitter') && (
                      <a
                        href={selectedMember.socialLinks.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="modal-social-link twitter"
                      >
                        <img src={twitterIcon} alt="Twitter" className="modal-social-icon-img" />
                        Twitter
                      </a>
                    )}
                    {selectedMember.socialLinks.youtube && !selectedMember.hiddenSocial?.includes('youtube') && (
                      <a
                        href={selectedMember.socialLinks.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="modal-social-link youtube"
                      >
                        <img src={youtubeIcon} alt="YouTube" className="modal-social-icon-img" />
                        YouTube
                      </a>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeadershipGrid;
